<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div>
  <app-module-header [showImportExportBtn]="showImportExportBtn" [hideAuditBtn]="isAddOrderAllowed"
    [showLastSync]="false" [showOrderExportBtn]="true"
    [orderExportBtnLabel]="btnDownloadInvoice" (orderExportBtnClick)="exportSelectedOrderErp()"></app-module-header>
</div>
<div appAccessProvider [accessCode]="{ menuCode: 'ORDER_ERP', pageCode: 'ALL', subPageCode: 'LIST' }">

  <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">

    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}"
          class="tab-label" translate>lbl_all</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.ALL}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="order_erp"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteOrderErpMsg"
          [header]="deleteOrderErpHeaderMsg"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddOrderErp()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateOrderErp($event)"
          [rowItems]="[]"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          [visible]="visible"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity"
          (onDelete)="onOrderErpDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          [isBulkSelection]="false">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>
<p-toast></p-toast>
<input hidden type="file" id="upload" (change)="onChange($event)"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" #uploader>